import { useState, useEffect } from 'react';
import Record from '../services/Recording';
import States from '../constants/States';
import Logger from '../utility/Logger';


const useRecordButton = (contactData) => {
  const { recordingDetailsStates } = States;

  const [recordButtonState, setRecordButtonState] = useState(recordingDetailsStates.EMPTY);
  useEffect(() => {
    if (contactData
      && contactData.currentContact) {
      const { currentContact } = contactData;
      const suspendRecording = () => {
        setRecordButtonState(recordingDetailsStates.WAITING_SUSPEND);
        const contactId = currentContact.getContactId();
        const originalContactId = currentContact.getOriginalContactId();
        Record(originalContactId, contactId, recordingDetailsStates.ACTION_SUSPEND).then((data) => {
          Logger.info(`success suspending recording ${JSON.stringify(data)}`);
          setRecordButtonState(recordingDetailsStates.SUSPENDED);
        }).catch((err) => {
          Logger.error(`error attempting to suspend recording ${JSON.stringify(err)}`);
          setRecordButtonState(recordingDetailsStates.ERROR_SUSPEND);
        });
      };
      const resumeRecording = () => {
        setRecordButtonState(recordingDetailsStates.WAITING_RESUME);
        const contactId = currentContact.getContactId();
        const originalContactId = currentContact.getOriginalContactId();
        Record(originalContactId, contactId, recordingDetailsStates.ACTION_RESUME).then((data) => {
          Logger.info(`success resuming recording ${JSON.stringify(data)}`);
          setRecordButtonState(recordingDetailsStates.RECORDING);
        }).catch((err) => {
          Logger.error(`error attempting to suspend recording ${JSON.stringify(err)}`);
          setRecordButtonState(recordingDetailsStates.ERROR_RUSUME);
        });
      };
      switch (recordButtonState) {
        case recordingDetailsStates.REQUEST_SUSPEND:
          suspendRecording();
          break;
        case recordingDetailsStates.REQUEST_RUSUME:
          resumeRecording();
          break;
        default:
          break;
      }
      currentContact.onConnected(() => {
        setRecordButtonState(
          recordingDetailsStates.RECORDING,
        );
      });

      currentContact.onEnded(() => {
        setRecordButtonState(recordingDetailsStates.EMPTY);
      });
    }
  }, [
    contactData,
    setRecordButtonState,
    recordButtonState,
    recordingDetailsStates.ACTION_RESUME,
    recordingDetailsStates.ACTION_SUSPEND,
    recordingDetailsStates.EMPTY,
    recordingDetailsStates.ERROR_RUSUME,
    recordingDetailsStates.ERROR_SUSPEND,
    recordingDetailsStates.RECORDING,
    recordingDetailsStates.REQUEST_RUSUME,
    recordingDetailsStates.REQUEST_SUSPEND,
    recordingDetailsStates.SUSPENDED,
    recordingDetailsStates.WAITING_RESUME,
    recordingDetailsStates.WAITING_SUSPEND
  ]);

  return {
    recordButtonState,
    setRecordButtonState,
  };
};

export default useRecordButton;
